export const GET_MYSPECIALTY_REQUEST = 'myspecialty/GET_MYSPECIALTY_REQUEST';
export const GET_MYSPECIALTY_SUCCESS = 'myspecialty/GET_MYSPECIALTY_SUCCESS';
export const GET_MYSPECIALTY_FAILURE = 'myspecialty/GET_MYSPECIALTY_FAILURE';


export const SAVE_MYSPECIALTY_REQUEST = 'myspecialty/SAVE_MYSPECIALTY_REQUEST';
export const SAVE_MYSPECIALTY_SUCCESS = 'myspecialty/SAVE_MYSPECIALTY_SUCCESS';
export const SAVE_MYSPECIALTY_FAILURE = 'myspecialty/SAVE_MYSPECIALTY_FAILURE';

export const EDIT_MYSPECIALTY="myspecialty/EDIT_MYSPECIALTY";